module.exports = __webpack_public_path__ + "img/lists-icon.89a4a82a.svg";